import { localeReducer as locale } from "data/reducers/locale";
import { reducer as currentUser } from "lib/api/currentUser";
import { reducer as search } from "lib/api/search";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  // app-specific reducers:
  // rwgps api reducers:
  search,
  currentUser,
  locale,
});

// TODO: we might want to mix in a 'routePicker' reducer here?
